import { FaPlus } from "react-icons/fa";
import Dropdown from "react-bootstrap/Dropdown";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { TiDelete } from "react-icons/ti";
import {
  addCarePlanTemplate,
  getCarePlanQueAndAns,
} from "../../../redux-toolkit/reducer/carePlanReducer";
import { DropdownButton } from "react-bootstrap";
import SavedPlanHistory from "../SavedPlanHistory";
import { ShowInfoSwal, ShowSwal } from "../../../utils/alertSwal";
import { CarePlanOptions, categoryIcons } from "../../../constants/constants";
import cx from "../clients.module.css";
import { toTitleCase } from "../../../utils/CommonFunctions";
import { currentCareSiteId } from "../../../redux-toolkit/reducer/switchSites";
import { riskProfileColorCodes } from "./constants";
import { formatToDateString } from "../../../utils/datechangehandler";
import {
  fetchAdministrativeCarePlan,
  fetchCarePlanCategories,
  fetchClientCarePlans,
  getClientCarePlanPdf,
} from "../../../redux-toolkit/reducer/clientCarePlanReducer";
import CareplanModal from "./CareplanModal";
import { httpAdmin } from "../../../Apis/commonApis";
import QnaModal from "./QnaModal";
import FormulationModal from "./FormulationModal";
import ContingencyPlanModal from "./ContingencyPlanModal";
import AdditionalPlanModal from "./AdditionalPlanModal";
import PreviewCarePlan from "./PreviewCarePlan";
import NextReviewModal from "./NextReviewModal";

const CarePlan = (props) => {
  const { clientId, CareplanAccess, clientAllData } = props;

  const { currentPlanName } = useSelector((state) => state.caresiteDataReducer);
  const isPlanBase = currentPlanName === "Base";

  const dispatch = useDispatch();
  let {
    clientCarePlans,
    existingCategoryTemplates,
    carePlanCategories,
    administrativeCarePlans,
    clientCarePlanPdfData,
  } = useSelector((state) => state?.clientCarePlanReducer);

  const [pageLoading, setPageLoading] = useState(false);

  useEffect(() => {
    dispatch(fetchCarePlanCategories());
    const qString = `?clientId=${clientId}&careHomeId=${currentCareSiteId}`;
    dispatch(fetchClientCarePlans(qString));
    dispatch(fetchAdministrativeCarePlan(clientId));
    dispatch(getCarePlanQueAndAns());
    fetchCarePlanPdfs();
  }, []);

  const fetchCarePlanPdfs = () => {
    let urlID = JSON.parse(localStorage.getItem("userData"));
    dispatch(
      getClientCarePlanPdf({
        adminId: urlID?._id,
        currentCareSiteId,
        clientId: clientId,
      })
    );
  };

  const deleteCarePlan = async (cPlanId) => {
    const queryEndpoint = `deleteClientCarePlan?id=${cPlanId}`;
    const res = await httpAdmin(queryEndpoint, "post", {}, null);
    ShowSwal(res.status, res.message ?? "");
    if (res.status) {
      const qString = `?clientId=${clientId}&careHomeId=${currentCareSiteId}`;
      dispatch(fetchClientCarePlans(qString));
    }
  };

  const allTasksClient = clientCarePlans?.reduce(
    (sum, obj) => sum + (obj?.docType === "template" ? 0 : obj?.Task?.length),
    0
  );
  const allRisksClient = clientCarePlans?.reduce(
    (sum, obj) =>
      sum + (obj?.docType === "template" ? 0 : obj?.risk_interventions?.length),
    0
  );

  /// administrator section

  const [showSavedPlanHistory, setShowSavedPlanHistory] = useState(false);
  const [plusButtonStatus, setPlusButtonStatus] = useState(false);
  const handlePlusBtnClick = () => {
    setPlusButtonStatus((prev) => !prev);
  };

  const [openQnaModal, setOpenQnaModal] = useState(false);
  const [openedQnaData, setOpenedQnaData] = useState([]);
  const handleOpenQnATemplateForm = (qnaData, catData) => {
    // if (isPlanBase) {
    //   ShowInfoSwal(
    //     `This feature is not available in the ${currentPlanName} Plan`
    //   );
    // } else {
    setOpenedQnaData({
      ...qnaData,
      clientName: clientAllData?.first_Name,
      catData,
    });
    setOpenQnaModal(true);
    // }
  };
  const handleCloseQnaModal = () => {
    setOpenedQnaData([]);
    setOpenQnaModal(false);
  };

  const [openCareplanFormModal, setOpenCareplanFormModal] = useState(false);
  const [openModalDetails, setOpenModalDetails] = useState(null);
  const handleOpenCarePlanModal = (type, catData, editData) => {
    setOpenModalDetails({
      catId: catData._id,
      catName: catData.categoryName,
      catApiKey: catData.apiKey,
      planType: type,
      isEdit: editData && !editData?.qnaData ? true : false,
      editData,
      qnaData: editData?.qnaData,
    });
    handleCloseQnaModal();
    setOpenCareplanFormModal(true);
  };
  const handleCloseCarePlanModal = () => {
    setOpenCareplanFormModal(false);
    setOpenModalDetails(null);
    setPlusButtonStatus(false);
  };

  const [openAdministrativeModal, setOpenAdministrativeModal] = useState("");
  const [openAdmModalDetails, setOpenAdmModalDetails] = useState(null);
  const handleOpenAdmModal = (type, catData, editData) => {
    let user_data = JSON.parse(localStorage.getItem("userData"));
    const carePlanType = type === "edit" ? editData.carePlanType : type;
    const commonData = {
      clientId,
      careHomeId: currentCareSiteId,
      last_update_date: new Date(),
      updated_by: `${user_data.firstName} ${user_data?.lastName}`,
      carePlanType,
    };
    setOpenAdmModalDetails({
      clientId,
      categoryId: catData._id,
      isEdit: editData ? true : false,
      editData: editData,
      commonData,
    });
    setOpenAdministrativeModal(carePlanType);
  };
  const handleCloseAdmModal = () => {
    setOpenAdministrativeModal("");
    setOpenAdmModalDetails(null);
    setPlusButtonStatus(false);
  };

  const [openPreviewCarePlan, setOpenPreviewCarePlan] = useState(false);
  const handleOpenPreviewCarePlan = (type) => {
    setOpenPreviewCarePlan(true);
  };
  const handleClosePreviewCarePlan = () => {
    setOpenPreviewCarePlan(false);
  };

  const [openNextReviewModal, setOpenNextReviewModal] = useState(false);
  const handleOpenNextReviewModal = () => {
    // if (isPlanBase) {
    //   ShowInfoSwal(
    //     `This feature is not available in the ${currentPlanName} Plan`
    //   );
    // } else {
    setOpenNextReviewModal(true);
    // }
  };
  const handleCloseNextReviewModal = () => {
    setOpenNextReviewModal(false);
  };

  return (
    <>
      {pageLoading && <p>Loading...</p>}
      {showSavedPlanHistory === false && pageLoading === false && (
        <>
          <div className="row btns_head mt-3 alignText justify-content-between">
            <div className="col-md-4 mt-2">
              <h5 className="tb_title d-flex justify-content-between mt-0">
                Plan Creation and Modification Tool
              </h5>
            </div>
            <div className="col-md-6 d-flex col-xl-5 justify-content-between">
              <p className="alltaskCounts">
                <strong>All Tasks: {allTasksClient ?? "0"}</strong>
                <strong className="ms-3">
                  All Risks: {allRisksClient ?? "0"}
                </strong>
              </p>
              {
                <span onClick={() => setShowSavedPlanHistory(true)}>
                  Plans History
                </span>
              }
              <div className="btns_head">
                <DropdownButton id="dropdown-basic-button" title="Actions">
                  <Dropdown.Item
                    disabled={CareplanAccess !== "full"}
                    onClick={() => {
                      isPlanBase
                        ? ShowInfoSwal(
                            `This feature is not available in the ${currentPlanName} Plan`
                          )
                        : handleOpenPreviewCarePlan();
                    }}
                  >
                    Preview Care Plan
                  </Dropdown.Item>
                  <Dropdown.Item
                    disabled={CareplanAccess !== "full"}
                    onClick={handleOpenNextReviewModal}
                  >
                    Set Reminder for Next Review{" "}
                  </Dropdown.Item>
                </DropdownButton>
              </div>
            </div>
          </div>

          <div className="accordion care_plan_list" id="accordionExample">
            {carePlanCategories.map((categoryData, cIndex) => {
              const categoryIcon = categoryIcons[categoryData.categoryName];
              const currentCatCarePlans = clientCarePlans.filter(
                (cPlan) =>
                  cPlan?.carePlanCategoryId === categoryData?._id &&
                  cPlan.docType === "careplan"
              );
              const currentCatTemplates = clientCarePlans.filter(
                (cPlan) =>
                  cPlan?.carePlanCategoryId === categoryData?._id &&
                  cPlan.docType === "template"
              );
              const totalCatTasks = currentCatCarePlans?.reduce(
                (sum, obj) => sum + obj?.Task?.length,
                0
              );
              const totalCatRisks = currentCatCarePlans?.reduce(
                (sum, obj) => sum + obj?.risk_interventions?.length,
                0
              );
              return (
                <div
                  className={`${cx.accordionItems} accordion-item`}
                  key={cIndex}
                >
                  <h2 className="accordion-header" id={`careplan_${cIndex}`}>
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapse_careplan_${cIndex}`}
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      <img
                        style={{
                          width: cIndex === 6 ? "31px" : "30px",
                        }}
                        alt=""
                        src={categoryIcon}
                      />{" "}
                      {categoryData.categoryName}
                      {categoryData?.categoryName === "Administrative" ? (
                        <p className="taskCounts"></p>
                      ) : (
                        <p className="taskCounts">
                          <span>Tasks: {totalCatTasks ?? "0"}</span>
                          <span className="ms-3">
                            Risks: {totalCatRisks ?? "0"}
                          </span>
                        </p>
                      )}
                    </button>
                  </h2>
                  <div
                    id={`collapse_careplan_${cIndex}`}
                    className="accordion-collapse collapse"
                    aria-labelledby={`careplan_${cIndex}`}
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <div className="row align-items-center mt-2">
                        {currentCatCarePlans?.map((planData, pIndex) => {
                          return (
                            <div className="col-md-3" key={pIndex}>
                              <div
                                className="living_box"
                                onClick={() =>
                                  handleOpenCarePlanModal(
                                    "careplan",
                                    categoryData,
                                    planData
                                  )
                                }
                              >
                                <h5>{planData.TemplateName}</h5>
                                <p>
                                  {formatToDateString(
                                    planData?.last_update_date
                                  )}
                                </p>
                                {planData.risk_profile && (
                                  <div
                                    className="fAction"
                                    style={{
                                      backgroundColor:
                                        riskProfileColorCodes[
                                          planData.risk_profile
                                        ],
                                    }}
                                  >
                                    {toTitleCase(planData.risk_profile)}
                                    <br />
                                    Risk
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}
                        {categoryData?.categoryName === "Administrative" &&
                          administrativeCarePlans?.map((planData, apIndex) => {
                            const updateddate = new Date(
                              planData?.last_update_date
                            ).toDateString();
                            return (
                              <div className="col-md-3" key={apIndex}>
                                <div
                                  className="living_box"
                                  onClick={() =>
                                    handleOpenAdmModal(
                                      "edit",
                                      categoryData,
                                      planData
                                    )
                                  }
                                >
                                  <h5 className="mb-0 pb-0">
                                    {planData.TemplateName}
                                  </h5>
                                  <small style={{ fontSize: "10px" }}>
                                    {planData?.carePlanType}
                                  </small>
                                  <p>{updateddate}</p>
                                </div>
                              </div>
                            );
                          })}

                        <div className="col-md-3">
                          <Dropdown className="addPlus" show={plusButtonStatus}>
                            <Dropdown.Toggle variant="success">
                              <FaPlus onClick={handlePlusBtnClick} />
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                              <Dropdown.Header>
                                <div className="actionBtns">
                                  {categoryData?.categoryName ===
                                  "Administrative" ? (
                                    <>
                                      <button
                                        className="btn"
                                        disabled={CareplanAccess !== "full"}
                                        onClick={() =>
                                          handleOpenAdmModal(
                                            "Formulation",
                                            categoryData,
                                            null
                                          )
                                        }
                                      >
                                        Formulation
                                      </button>

                                      <button
                                        className="btn"
                                        disabled={CareplanAccess !== "full"}
                                        onClick={() =>
                                          handleOpenAdmModal(
                                            "Contingency Plan",
                                            categoryData,
                                            null
                                          )
                                        }
                                      >
                                        Contingency Plan
                                      </button>
                                      <button
                                        className="btn"
                                        disabled={CareplanAccess !== "full"}
                                        onClick={() =>
                                          handleOpenAdmModal(
                                            "Additional Support Plan",
                                            categoryData,
                                            null
                                          )
                                        }
                                      >
                                        Additional Support Plan
                                      </button>
                                    </>
                                  ) : (
                                    <>
                                      <button
                                        className="btn"
                                        disabled={CareplanAccess !== "full"}
                                        onClick={() =>
                                          handleOpenCarePlanModal(
                                            "careplan",
                                            categoryData,
                                            null
                                          )
                                        }
                                      >
                                        Create New
                                      </button>
                                      <button
                                        disabled={CareplanAccess !== "full"}
                                        className="btn"
                                        onClick={() =>
                                          handleOpenCarePlanModal(
                                            "template",
                                            categoryData,
                                            null
                                          )
                                        }
                                      >
                                        Create Template
                                      </button>
                                    </>
                                  )}
                                  <button
                                    className="btn"
                                    onClick={() => setPlusButtonStatus(false)}
                                  >
                                    Close
                                  </button>
                                </div>
                              </Dropdown.Header>
                              {categoryData?.categoryName !==
                                "Administrative" && (
                                <div className="row">
                                  <div className="col-md-12 mt-3">
                                    <h6>
                                      Choose from Predefined Assessment
                                      Templates
                                    </h6>
                                  </div>
                                  {existingCategoryTemplates?.[
                                    categoryData?.apiKey
                                  ]?.map((template, tempIndex) => {
                                    return (
                                      <div
                                        key={tempIndex}
                                        className="col-md-6"
                                        onClick={() =>
                                          handleOpenQnATemplateForm(
                                            template,
                                            categoryData
                                          )
                                        }
                                      >
                                        <div
                                          className={`living_box ${"active"}`}
                                        >
                                          <h5>{template.name}</h5>
                                          <p>Updated: ---- ----- -----</p>
                                        </div>
                                      </div>
                                    );
                                  })}
                                  {currentCatTemplates?.map(
                                    (template, tempIndex) => {
                                      const updateddate = new Date(
                                        template?.last_update_date
                                      ).toDateString();
                                      return (
                                        <div
                                          className="col-md-6 position-relative"
                                          key={tempIndex}
                                        >
                                          <div
                                            className={`living_box`}
                                            style={{ padding: "0 0 15px 8px" }}
                                          >
                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent: "end",
                                              }}
                                            >
                                              <TiDelete
                                                onClick={() => {
                                                  deleteCarePlan(template._id);
                                                }}
                                              />
                                            </div>
                                            <div
                                              onClick={() =>
                                                handleOpenCarePlanModal(
                                                  "template",
                                                  categoryData,
                                                  template
                                                )
                                              }
                                            >
                                              <h5>{template.TemplateName}</h5>
                                              <p>Updated: {updateddate}</p>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    }
                                  )}
                                </div>
                              )}
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}

      {showSavedPlanHistory === true && (
        <>
          <div className="btns_head mt-3 setPostion">
            <a onClick={() => setShowSavedPlanHistory(false)}>Back </a>
          </div>
          <SavedPlanHistory rows={clientCarePlanPdfData} />
        </>
      )}

      {openCareplanFormModal && (
        <CareplanModal
          open={openCareplanFormModal}
          handleCloseCarePlanModal={handleCloseCarePlanModal}
          openModalDetails={openModalDetails}
          CareplanAccess={CareplanAccess}
        />
      )}

      <QnaModal
        open={openQnaModal}
        handleCloseQnaModal={handleCloseQnaModal}
        openedQnaData={openedQnaData}
        handleNext={handleOpenCarePlanModal}
      />

      {openAdministrativeModal === "Formulation" && (
        <FormulationModal
          open={openAdministrativeModal === "Formulation"}
          handleCloseAdmModal={handleCloseAdmModal}
          openAdmModalDetails={openAdmModalDetails}
          CareplanAccess={CareplanAccess}
        />
      )}

      {openAdministrativeModal === "Contingency Plan" && (
        <ContingencyPlanModal
          open={openAdministrativeModal === "Contingency Plan"}
          handleCloseAdmModal={handleCloseAdmModal}
          openAdmModalDetails={openAdmModalDetails}
          CareplanAccess={CareplanAccess}
        />
      )}

      {openAdministrativeModal === "Additional Support Plan" && (
        <AdditionalPlanModal
          open={openAdministrativeModal === "Additional Support Plan"}
          handleCloseAdmModal={handleCloseAdmModal}
          openAdmModalDetails={openAdmModalDetails}
          CareplanAccess={CareplanAccess}
        />
      )}

      <PreviewCarePlan
        open={openPreviewCarePlan}
        handleClose={handleClosePreviewCarePlan}
      />

      <NextReviewModal
        open={openNextReviewModal}
        handleClose={handleCloseNextReviewModal}
        fetchCarePlanPdfs={fetchCarePlanPdfs}
      />
    </>
  );
};

export default CarePlan;
